import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Avatar from "@mui/material/Avatar";
import { useMediaQuery } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { logoutUser } from "../../redux/authSlice";
import { markAllRead } from "../../redux/liveNotificationsSlice";

export default function NavbarUserMenu() {
  const isMobile = useMediaQuery("(max-width:767px)");
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifAnchorEl, setNotifAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isNotifMenuOpen = Boolean(notifAnchorEl);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get user data from Redux store
  const { userData } = useSelector((state) => state.auth);
  const user = userData?.user || userData; // Handle different structure possibilities

  const { items: liveNotifications, unreadCount } = useSelector(
    (state) => state.liveNotifications
  );

  // Format last login date (using updated_at as proxy since we don't have last login)
  const lastLoginDate = user?.updated_at
    ? moment(user.updated_at).format("DD-MM-YYYY  hh:mm a")
    : "غير متوفر";

  // moment(params.row.created_at).format("YYYY-MM-DD")

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    handleMenuClose();
    navigate("/login");
  };

  const handleProfile = () => {
    handleMenuClose();
    navigate("/profile");
  };

  const handleNotifMenuOpen = (event) => {
    setNotifAnchorEl(event.currentTarget);
    if (unreadCount > 0) {
      dispatch(markAllRead());
    }
  };

  const handleNotifMenuClose = () => {
    setNotifAnchorEl(null);
  };

  const handleNotifItemClick = (link) => {
    handleNotifMenuClose();
    navigate(link);
  };

  const renderNotifMenu = (
    <Menu
      disableScrollLock
      anchorEl={notifAnchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      id="admin-notifications-menu"
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isNotifMenuOpen}
      onClose={handleNotifMenuClose}
      PaperProps={{ sx: { width: 320, maxHeight: 420 } }}
    >
      {liveNotifications.length === 0 ? (
        <MenuItem disabled>لا توجد إشعارات جديدة</MenuItem>
      ) : (
        liveNotifications.map((item) => (
          <MenuItem key={item.id} onClick={() => handleNotifItemClick(item.link)}>
            <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
              <Typography variant="body2" noWrap>
                {item.title}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {moment(item.date).fromNow()}
              </Typography>
            </Box>
          </MenuItem>
        ))
      )}
      {liveNotifications.length > 0 && (
        <>
          <Divider />
          <MenuItem onClick={() => handleNotifItemClick("/notifications")}>
            عرض كل الإشعارات
          </MenuItem>
        </>
      )}
    </Menu>
  );

  const renderMenu = (
    <Menu
      disableScrollLock
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      id="primary-search-account-menu"
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {isMobile && (
        <MenuItem onClick={handleMenuClose}>
          مرحبا
          <br />
          {user?.name || "المستخدم"}
        </MenuItem>
      )}

      {isMobile && (
        <MenuItem onClick={handleMenuClose}>
          اخر ظهور
          <br />
          {lastLoginDate}
        </MenuItem>
      )}

      <MenuItem onClick={handleProfile}>
        <AccountCircleIcon sx={{ marginRight: 1 }} />
        الملف الشخصي
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <LogoutIcon sx={{ marginRight: 1 }} />
        تسجيل الخروج
      </MenuItem>
    </Menu>
  );

  return (
    <Box>
      <Box
        sx={{
          display: { md: "flex" },
        }}
      >
        <IconButton
          size="large"
          aria-label={`show ${unreadCount} new notifications`}
          aria-controls="admin-notifications-menu"
          aria-haspopup="true"
          onClick={handleNotifMenuOpen}
          color="inherit"
          sx={{
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Badge badgeContent={unreadCount} color="error">
            <NotificationsIcon style={{ color: "white" }} />
          </Badge>
        </IconButton>

        <IconButton
          size="large"
          edge="end"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          onClick={handleProfileMenuOpen}
          color="inherit"
          sx={{
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Avatar sx={{ marginLeft: 1 }}>
            {user?.name ? user.name.charAt(0).toUpperCase() : "U"}
          </Avatar>
          {!isMobile && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                fontSize: "14px",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span className="name-with-arrow">
                  {user?.name || "المستخدم"}
                </span>
              </div>
              <span>اخر ظهور {lastLoginDate}</span>
            </div>
          )}
        </IconButton>
      </Box>
      {renderMenu}
      {renderNotifMenu}
    </Box>
  );
}
